import { DATE_FORMAT_MASK, MONTHS, MONTHS2 } from '../const';

export const ACTION_FETCH = 'fetch';
export const STORE_MODULE_NAME = 'activityDay';
export const TITLE_DEFAULT = 'Список мероприятий на ';
export const TEXT = 'Вернуться в календарь мероприятий';

export { DATE_FORMAT_MASK, MONTHS, MONTHS2 };



// WEBPACK FOOTER //
// ./src/pages/activities/day/const.ts